

import {
    type MailInfo,
    type MailSetRead,
} from '@/socket/mail/dto/index';

// ↓ 二期新增的部分 
export const useMailSocket = () => {
    const rootPath = 'mail';
    
    const EMIT_MAIL_COUNT = async ()=>{
        const res = await asyncEmit<{
            response: {
                systemCount: number;
                personCount: number;
            },
        }>(
            `${rootPath}.Count`,
            {},
        );
        return res;
    };

    const EMIT_MAIL_SET_READ = async (
        params: MailSetRead,
    )=>{
        const res = await asyncEmit<{
            response: object; // 返回空对象 
        }>(
            `${rootPath}.Read`,
            params,
        );
        return res;
    };

    const EMIT_MAIL_INFO = async (
        params:MailInfo, 
    )=>{
        const res = await asyncEmit(
            `${rootPath}.Info`,
            params,
        );
        return res;
    };

    return {
        EMIT_MAIL_COUNT,
        EMIT_MAIL_SET_READ,
        EMIT_MAIL_INFO,
    };
};

